import React, { Component, Fragment } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import $ from 'jquery';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import { getTeachers, getTransactions, saveItemTransaction } from './bulkTransactionService';
import { _addNotification, _addNotificationError, groupBy } from '../../../../server/util';
import CustomSubmit from '../../../Misc/customSubmit';
import Modal from 'react-modal'
import moment from 'moment';

const CheckboxTable = checkboxHOC(ReactTable);

const mealsData={
    Lunch:'Lunch Served',
    Breakfast:'Breakfast Served',
    Snack:'Snack Served',
    Dinner:'Dinner Served'
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class MealCountComponent extends Component {
    constructor(props){
        super(props);
        this.state={
            tabIndex:0,
            ttabIndex:0,
            selectedRows:[],
            selection: [],
            selectAll:false,
            data:[],
            filterData:[],
            search:'',
            teachers:{},
            tabChangeModal:false,
            tempTabIndex:undefined
        }

    }
    componentDidMount=()=>{
        this.getData();       
    }
    getTeachersList=()=>{
        const {setLoading}=this.props;
        setLoading(true);
        getTeachers({
                schoolYear:sessionStorage.getItem('schoolYearValue'),
                schoolId:sessionStorage.getItem('SchoolId')
            }).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                setLoading(false);
                this.setState({
                    teachers:data.resp
                },()=>{
                    this.getData();
                })

            }).catch(error => {
                setLoading(false);
            console.log("Loading Report Failed", error);
        });
    }
    getCols=()=>{
        let columns=[];
        columns.push({
            accessor: 'mealName',
            Header: 'DESCRIPTION',
            Cell: props => props.original.mealName,
            style: { textAlign: 'left' }
        }); 
       
        columns.push({
            Header: 'COUNT',
            width:150,
            Cell: ({ row }) => <input type="number" min='0' className={'form-control'} value={row._original.totalQty}  
            onChange={(event) => this.handleCountChange(row._original._id, event.target.value)}
             />,
            style: { textAlign: 'center' }
        });
        /* columns.push({
            accessor: 'totalQty',
            Header: 'Total Qty',
            width:150,
            Cell: props => props.original.totalQty,
            style: { textAlign: 'right', paddingRight:'30px' }
        });  */     
        return columns;
    }
    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        let selectedRows=[...this.state.selectedRows]
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            selectedRows=[
               ... selectedRows.slice(0,keyIndex),
                ...selectedRows.slice(keyIndex + 1)
            ]
        } else {
            // it does not exist so add it
            selection.push(key);
            selectedRows.push(row);
        }
        // update the state
        this.setState({ selection,selectedRows });
        this.setState({ selectAll: false });
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectedRows=[]
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original._id);
                selectedRows.push(item._original)
            });
        }
        this.setState({ selectAll, selection,selectedRows });
    };
    isSelected = key => {
        const res=(this.state.selection||[]).find((item)=>{
            const _item=((item||'')+'').replace('select-','');
            return _item==key;
        });
        if(res){
            return true;
        }else{
            return false;
        }
    };
    getDate_MenuTypeChangeData=()=>{
        this.setState({tabIndex:0,ttabIndex:0,  selectedRows:[],
            selection: []},()=>{
            this.getData()
        });
    }
    getData=()=>{
        const {selectedDate,mealType, setLoading, gradeList}=this.props;
        const {teachers}=this.state;
        this.setState({tabIndex:0,ttabIndex:0,  selectedRows:[],
            selection: [],data:[],filterData:[]});
        setLoading( true); 
        let finalData=[];
        const mealTypeItem=mealsData[mealType];
        gradeList.map(grade=>{
                const recObj={};
                recObj.mealId=0;
                recObj.mealName=mealTypeItem;
                recObj.grade=grade.value;
                recObj.mealType=mealType.toUpperCase();
                recObj.teacher=undefined;
                recObj.totalQty=0;
                finalData.push(recObj);
        });
        setLoading( false); 
        this.setState({ tabIndex:0,ttabIndex:0, data:finalData.map((rec,i)=>{
            rec._id=(i+1);
            rec.editTotal=0;//rec.totalQty||0;
            rec.totalQty=0;
            return rec;
        })},()=>{
            this.filterOrderData(finalData||[],0)
        });

    }
    filterOrderData=(data,tabIndex,ttabIndex,search='')=>{
        let list=[];
        const tabIndexVal=this.props.gradeList[tabIndex].value;         
       
            list= data.filter((rec)=>{
                return rec.grade==tabIndexVal;
            });
        this.setState({filterData: search.length>0? [...list].filter(rec=>{
            return (rec.mealName||'').toUpperCase().startsWith(search.toUpperCase())
        }):[...list] });
    }
    handleCountChange = (id, value) => {
        let tabData = this.state.data.map((item) => ({
            ...item,
            totalQty: item._id === id ? (value >= 0 ? parseInt(value) : 0) : item.totalQty,
        }));

        let _filterData = this.state.filterData.map((item) => {
            if (item._id === id) {
                return { ...item, totalQty: value >= 0 ? parseInt(value) : 0 };
            }
            return item;
        });
         const _selectedRows=this.state.selectedRows.map((item) => {
            if (item._id === id) {
                return { ...item, totalQty: value >= 0 ? parseInt(value) : 0 };
            }
            return item;
        });

        this.setState({ filterData: [..._filterData], 
            data: [...tabData], 
            selectedRows:[..._selectedRows] });
    };
    getSystemDateTime = () =>{
        const {selectedDate}=this.props;
        const selectedDateTime=moment(selectedDate).set( {
           hour:   moment().get('hour'),
           minute: moment().get('minute'),
           second: moment().get('second')
       })
       let _datetime=moment.utc(selectedDateTime).format('YYYY-MM-DDTH:mm:ss');
       return _datetime+'Z'; 
      // return moment(this.state.startDate).format('YYYY-MM-DD');
   }
    saveTransaction=(e,callback)=>{
        const {setLoading, mealType}=this.props;
        const {selectedRows}=this.state;
        e.preventDefault();
        if(selectedRows.length > 0){
            
            const systemDateTime=this.getSystemDateTime();
            let schoolId = sessionStorage.getItem('SchoolId');
            const loginUserInfo=JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
            const finalReqObj=[];

            const gradeGroup=groupBy(selectedRows,'grade');
            Object.keys(gradeGroup).map(grade=>{
                if(gradeGroup[grade].length>0){
                    const teacherGroup=groupBy(gradeGroup[grade]||[],'teacher');
                    Object.keys(teacherGroup).map(teacher=>{
                        const gradeObj={
                            grade: grade==0?'All':grade,
                            mealType: (mealType==='Lunch'?'MEAL':mealType).toUpperCase(),
                            qty:0,
                            teacherName:(teacher||'')=='undefined'?undefined:(teacher||''),
                            trxDate:systemDateTime,
                            transactionItems:[]
                        };
                        teacherGroup[teacher].map(rec=>{
                            const recObj={
                                menuItemId: rec.mealId,
                                qty:rec.totalQty
                            };
                            gradeObj.transactionItems.push(recObj);
                            gradeObj.mealType=(rec.mealType==='LUNCH'?'MEAL':rec.mealType).toUpperCase(),
                            gradeObj.qty=gradeObj.qty+rec.totalQty;    
                        });
                        finalReqObj.push(gradeObj);
                    })                    
                }                
            });
            setLoading(true);
             saveItemTransaction({
                schoolId,
                mealType,
                userId:loginUserInfo.userId,
                reqBody:finalReqObj
            }).then((response) => {
                if (response.status === 200) {
                    setLoading(false);                        
                    this.setState({ data:[], selectedRows:[], selection:[] })
                    _addNotification('Bulk transaction done successfully', this.props);
                    callback(true);
                    this.getData();
                } else if (!response.ok) {
                    throw Error(response.statusText);
                }
            }).catch(
                (error) => {
                    setLoading(false);
                    callback(true);
                    _addNotificationError('Bulk transaction failed ! Try again.', this.props);
                    console.log('Send Notification Error', error)
                }
            );

        }else{
            _addNotificationError('Please select at least one item.', this.props);
            callback(true);
        }
    }
    onClickOk=()=>{
        const {data,filterData, tempTabIndex}=this.state;
        const idx=tempTabIndex;
        data.map(rec=>{
            rec.totalQty=0;
        });
        filterData.map(rec=>{
            rec.totalQty=0;
        });
        this.setState({ selectAll: false,
            tabIndex:tempTabIndex, 
            tempTabIndex:undefined, 
            selection:[], 
            selectedRows:[], 
            data:data,
            filterData:filterData, 
            search:'',
            tabChangeModal:false
         },()=>{
            this.filterOrderData(data, idx,0);;
        });
    }
    onClickCancel=()=>{
        const {tempTabIndex}=this.state;
        this.setState({
            tempTabIndex:undefined,
            tabChangeModal:false
         });
    }
    render() {
        const {gradeList, selectedDate, mealType}=this.props;
        const { selectAll, data, filterData, tabIndex, ttabIndex, teachers } = this.state;
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            selectAll, 
            isSelected,
            toggleSelection,
            toggleAll,           
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }
        
        return (
            <Fragment>
                <Tabs selectedIndex={tabIndex} onSelect={(idx) => {
                    const {selectedRows,data,filterData}=this.state;
                    if((tabIndex==0|| idx==0) && selectedRows.length>0){
                        this.setState({tempTabIndex:idx,tabChangeModal:true});                       
                    }else{
                        this.setState({ selectAll: false,tabIndex:idx, search:'' },()=>{
                            this.filterOrderData(data, idx,0);;
                        });
                    }                                                               
                }}>
                    <TabList>
                    {
                        gradeList.map((item)=> {
                            return <Tab > {item.label}</Tab>
                        }, this)
                    }
                    </TabList>
                    {
                        gradeList.map((grade,i)=>{
                            const teachersList=((teachers||{})[grade.value]||[]);
                            return(<TabPanel>
                                <div className="row">
                                    <div className='col-md-12 form-group'>
                                        <div className="row">
                                                            <div className='col-md-12 form-group'>
                                                                <CustomSubmit id="addSchool" type="button" className="btn btn-success button-sm pull-right"
                                                                    style={{ margin: '0' }} 
                                                                    handleSubmit={(e,callback) => this.saveTransaction(e,callback)} >
                                                                        <i className="glyphicon glyphicon-ok"></i> Save Transaction</CustomSubmit>
                                                            </div>
                                                            <div className="col-xs-12">
                                                                <CheckboxTable id={i+1}
                                                                    ref={r => (this.checkboxTable = r)}
                                                                        data={filterData}
                                                                        columns={this.getCols()}
                                                                        defaultPageSize={10}
                                                                        className="-striped -highlight"
                                                                        {...checkboxProps}  minRows={0} />
                                                            </div>
                                                        </div>

                                    </div>
                                </div>
                            </TabPanel>); 
                        })

                    }                                                   
                </Tabs> 
                <Modal
                    isOpen={this.state.tabChangeModal}
                    onRequestClose={() => this.onClickCancel()}
                    style={deleteStyles}
                    contentLabel="Publish">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Confirmation</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to change the tab?</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.onClickCancel()}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                        </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={()=>this.onClickOk()}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                        </button>
                    </div>
                </Modal>

            </Fragment>
        );
    }
}

export default MealCountComponent;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/bulkTransactions/mealCountComponent.js